import styled from '@emotion/styled';
import TableCell from '@mui/material/TableCell';

const BodyTableCellFlexSales = styled(TableCell)`
  padding-top: 0;
  padding-bottom: 0;
`;

export default BodyTableCellFlexSales;
